import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Routes from '../routes';
import Header from '../containers/Header';
import Footer from './Footer';
import Dialog from '../containers/Dialog';
import CalculationRenameDialog from './dialogs/CalculationRenameDialog';
import CreateCalculationDialog from './dialogs/CreateCalculationDialog';
import SplashScreenDialog from './dialogs/SplashScreenDialog';
import PrintPdfDialog from './dialogs/PrintPdfDialog';
import CalculationRemoveConfirmDialog from './dialogs/CalculationRemoveConfirmDialog';
import ProjectDetails from './dialogs/ProjectDetails';
import ProjectCreate from './dialogs/ProjectCreate';
import ProjectRemoveConfirmDialog from './dialogs/ProjectRemoveConfirmDialog';
import ProjectSaveDialog from './dialogs/ProjectSave';
import Login from './dialogs/Login';
import Settings from './dialogs/Settings';
import ErrorDialog from './dialogs/ErrorDialog';
import InfoScreen from './InfoScreen';

import { adobeClickInsulationObject } from '../utils/analytics';

import {
  PROJECT_DETAILS_DIALOG,
  CREATE_NEW_PROJECT_DIALOG,
  PROJECT_SAVE_DIALOG,

  ERROR_DIALOG,
} from '../modules/dialogs';

import {
  toggleSplashScreen,
} from '../modules/app';

import {
  getUIText,
} from '../utils/index';

import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import red from '../utils/paroc-palette';

// see https://material-ui-next.com/customization/themes/
const theme = createTheme({
  palette: {
    primary: red,
  },
  typography: {
    button: {
      fontWeight: 600,
    },
  },
});

class App extends Component {
	render() {
    const {
      app,
      user,
      info,
      translations,
      dialogs,
      onToggleSplashScreen,
    } = this.props;

    const {
      creatingPDF,
    } = app;

    const {
      logOutProgress,
    } = user;

		return (
      <ThemeProvider theme={theme}>
  			<div>
  	      { creatingPDF ? <Dialog /> : null}
  	      <Header />
  	      { Routes }
  	      <Footer />
          <Login open={app.loginOpen} />
          <CreateCalculationDialog open={app.calculationCreateDialogOpen} />
          <CalculationRenameDialog open={app.calculationRenameDialogOpen} />
          <CalculationRemoveConfirmDialog open={app.calculationRemoveDialogOpen} />
          <ProjectRemoveConfirmDialog open={app.projectRemoveDialogOpen} />
          <SplashScreenDialog onClickHandler={() => onToggleSplashScreen(app.language, translations)} open={app.splashScreenDialogOpen} app={app} translations={translations} />
          <PrintPdfDialog open={app.printPdfDialogOpen} />
          {app.settingsOpen
            ? <Settings open={app.settingsOpen} menuLayout={app.settingsMenuLayout} />
            : null
          }

          {
            dialogs.dialog === PROJECT_DETAILS_DIALOG && dialogs.open
              ? <ProjectDetails open={dialogs.open} />
              : null
          }
          {
            dialogs.dialog === CREATE_NEW_PROJECT_DIALOG && dialogs.open
              ? <ProjectCreate open={dialogs.open} />
              : null
          }
          {
            dialogs.dialog === PROJECT_SAVE_DIALOG && dialogs.open
              ? <ProjectSaveDialog open={dialogs.open} />
              : null
          }
          {
            dialogs.dialog === ERROR_DIALOG && dialogs.open
              ? <ErrorDialog open={dialogs.open} />
              : null
          }

          { logOutProgress &&
            <div className="loader-screen">
              <div className="message">
                {getUIText('GENERAL-LOGGGING_OUT', app.language, translations)}
              </div>
            </div>
          }
          {info.visible && <InfoScreen />}
        </div>
      </ThemeProvider>
		);
	}
}

App.propTypes = {
    dialogs: PropTypes.object,
    info: PropTypes.object,
    user: PropTypes.object,
    app: PropTypes.object,
    translations: PropTypes.object,
    onToggleSplashScreen: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        dialogs: state.dialogs,
        info: state.info,
        user: state.user,
        app: state.app,
        translations: state.translations
    };
};


const mapDispatchToProps = (dispatch) => {
    return {
      onToggleSplashScreen: (appLanguage, translations) => {
        // here adobe page load event
        adobeClickInsulationObject(getUIText('CALCULATION-FLAT_SURFACE', appLanguage, translations),
            getUIText('CALCULATION-FLAT_SURFACE', 'English', translations), 'select object');
        dispatch(toggleSplashScreen());
      },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(App);
